import script from "./AuthHero.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthHero.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__